<script lang="ts">
export default {
  name: 'KkItem',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { KkBox } from '../../../../components/base'
import { toNumberLocaleString } from '../../../../modules/localeString'
import type {Item} from '../../types'
const { t } = useI18n()

interface Props {
  item: Item
  selectedService: string
}
const props = defineProps<Props>()

const showImage = computed<boolean>(() => props.selectedService != 'google')
const showRecommend = computed<boolean>(() => props.selectedService != 'google')

const styles = computed(() => {
  const styles: { [key: string]: string } = {}
  if (['yahoo_place', 'tabelog'].includes(props.selectedService)) styles['white-space'] = 'pre-wrap'

  return styles
})
</script>

<template>
  <div class="foodMenuItem">
    <KkBox border>
      <template #content>
        <div class="foodMenuItem__container">
          <div v-if="item.imageUrl && showImage" class="foodMenuItem__image">
            <img :src="item.imageUrl" :alt="item.label">
          </div>
          <div class="foodMenuItem__content">
            <div class="foodMenuItem__content--above">
              <div>
                <span v-if="item.isRecommend && showRecommend" class="recommendBadge">
                  {{ t('pages.CompaniesFoodMenus.edit.item.recommend.badge') }}
                </span>
                {{ item.label }}
              </div>
              <div v-if="item.price">{{ t('labels.currency.yen', { number: toNumberLocaleString(item.price) }) }}</div>
            </div>
            <div class="foodMenuItem__content--bottom" :style="styles">{{ item.description }}</div>
          </div>
        </div>
      </template>
    </KkBox>
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.foodMenuItem {
  margin-bottom: 16px;
  word-wrap: break-word;

  &__container{
    display: flex;
    justify-content: space-between;
  }

  &__recommendDescription{
    margin-top: 10px;
  }

  &__content {
    width: 100%;
    padding-right: 30px;

    &--above {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-weight: 700;
    }

    &--bottom {
      color: #9c9c9c;
    }
  }

  &__image {
    display: block;
    width: 20%;
    height: 100%;
    margin-right: 16px;
    img {
      aspect-ratio: 1/1;
      object-fit: cover;
      border: 1px solid #E3E3E3;
      border-radius: 4px;
    }
  }
}
.recommendBadge {
  background: #393a3e;
  border-radius: 12px;
  font-weight: bold;
  color: #FFF;
  font-size: 12px;
  padding: 4px 6px;
}
</style>
